import { AppConfiguration } from '../interfaces/app-configuration';
import { Inject, Injectable, Optional } from '@angular/core';
import { OscConfiguration } from '../models/osc-configuration';
import { OscPlatform } from '../enums/osc-platform';
import { HttpClient } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
    private oscConfiguration: OscConfiguration;
    private oscPlatform: OscPlatform;
    private appConfiguration: AppConfiguration;

  constructor(public httpClient: HttpClient, @Optional() @Inject('PLATFORM') oscPlatform?: OscPlatform) {
    this.oscPlatform = oscPlatform ? oscPlatform : OscPlatform.Web;
   
    }

    public load(path: string): Promise<AppConfiguration> {
      return this.httpClient.get<AppConfiguration>(path)
        .pipe(
          tap(response => {
              this.oscConfiguration = {
                appStoreEndpointUrl: response['appStoreEndpointUrl'],
                authenticationEndpointUrl: response['authenticationEndpointUrl'],
                environmentName: response['environmentName'],
                myAppsEndpointUrl: response['myAppsEndpointUrl'],
                myDevicesEndpointUrl: response['myDevicesEndpointUrl'],
                myAccountUrl: response['myAccountUrl'],
                baseUrl: response['baseUrl'],
                featureToggle: response['featureToggle'],
                imsContentUrl: response['imsContentUrl'],
                reportTemplateBuilderEndpointUrl: response['reportTemplateBuilderEndpointUrl'],
                rootAppEndpointUrl: response['rootAppEndpointUrl'],
                powerBiEndpointUrl: response['powerBiEndpointUrl']
              }
            }
          ),
          tap(response => {
            this.appConfiguration = response;
          }),
          catchError(e => { console.log(`Error during load config file: ${JSON.stringify(e)}`); return null; })
        ).toPromise();
    }

    public getConfiguration(): OscConfiguration {
      return this.oscConfiguration;
    }

    public getAppConfiguration<T = any>(key: string): T {
      return this.appConfiguration[key];
    }

    public getPlatform(): OscPlatform {
      return this.oscPlatform;
    }

    public isWebApp(): boolean {
      return this.oscPlatform === OscPlatform.Web;
    }
}
